module.exports = __webpack_public_path__ + "img/collection-memoireRings@2x.61da409.webp";